module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "fixed-part detail-part"
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: _vm.headerBackStatus
      }
    }
  }, [(!_vm.headerBackStatus) ? _c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        _vm.goTodo()
      }
    },
    slot: "left"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/back.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  }), _vm._v(" "), _c('span', {
    staticClass: "jump-back"
  }, [_vm._v("返回")])]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n      "), (!_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/user-white.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  })]) : _vm._e(), _vm._v(" "), (_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_vm._v("\n        " + _vm._s(_vm.userName) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('button-tab', [_c('button-tab-item', {
    attrs: {
      "selected": ""
    },
    on: {
      "on-item-click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("\n          详情列表\n      ")]), _vm._v(" "), _c('button-tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab(2)
      }
    }
  }, [_vm._v("\n          流程意见\n      ")]), _vm._v(" "), _c('button-tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab(3)
      }
    }
  }, [_vm._v("\n          查看附件\n      ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scroll-part"
  }, [(_vm.id.length > 0) ? _c('detail-page', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listShow),
      expression: "listShow"
    }],
    attrs: {
      "idArr": [this.id, this.flowId, this.stepId]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.auditData.length > 0) ? _c('detail-msg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msgShow),
      expression: "msgShow"
    }],
    attrs: {
      "auditData": this.auditData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fileShow) ? _c('detail-file', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileShow),
      expression: "fileShow"
    }],
    attrs: {
      "fileData": _vm.fileData,
      "fileList": _vm.fileList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.defaultFileShow) ? _c('detail-default-file', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaultFileShow),
      expression: "defaultFileShow"
    }],
    attrs: {
      "fileData": _vm.fileData,
      "idArr": [this.id, this.flowId, this.stepId]
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "submit-dialog",
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_c('div', {
    staticClass: "dialog-close-btn",
    on: {
      "click": function($event) {
        _vm.showToast = false
      }
    }
  }, [_c('span', {
    staticClass: "vux-close"
  }, [_c('img', {
    staticClass: "img-user",
    staticStyle: {
      "padding": "8px 10px 0px 0px"
    },
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/close.png"),
      "width": "24",
      "height": "24"
    },
    slot: "label"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticStyle: {
      "padding": "0px 15px"
    }
  }, [_c('span', {
    staticClass: "dialog-title"
  }, [_vm._v("选择节点")]), _vm._v(" "), (_vm.nextFlowNodeArr.length === 1) ? _c('checker', {
    staticClass: "dialog-part",
    attrs: {
      "selected-item-class": "selected-item"
    },
    on: {
      "on-change": _vm.singleCheck
    },
    model: {
      value: (_vm.checkNodeArr),
      callback: function($$v) {
        _vm.checkNodeArr = $$v
      },
      expression: "checkNodeArr"
    }
  }, _vm._l((_vm.nextFlowNodeArr), function(item) {
    return _c('checker-item', {
      key: item.id,
      staticClass: "selected-item",
      attrs: {
        "value": item.stepId + ',' + item.id + ',' + item.openOperatorManualChoose + ',' + item.todoResolveMode
      }
    }, [_vm._v(_vm._s(item.name))])
  })) : _c('checker', {
    staticClass: "dialog-part",
    attrs: {
      "selected-item-class": "selected-item"
    },
    on: {
      "on-change": _vm.singleCheck
    },
    model: {
      value: (_vm.checkNodeArr),
      callback: function($$v) {
        _vm.checkNodeArr = $$v
      },
      expression: "checkNodeArr"
    }
  }, _vm._l((_vm.nextFlowNodeArr), function(item) {
    return _c('checker-item', {
      key: item.id,
      attrs: {
        "value": item.stepId + ',' + item.id + ',' + item.openOperatorManualChoose + ',' + item.todoResolveMode
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1), _vm._v(" "), (_vm.nextFlowStaffArr.length > 0) ? _c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('span', {
    staticClass: "dialog-title"
  }, [_vm._v("选择人员")]), _vm._v(" "), _c('checker', {
    staticClass: "dialog-part",
    attrs: {
      "max": 10,
      "type": "checkbox",
      "selected-item-class": "selected-item"
    },
    on: {
      "on-change": _vm.multipleCheck
    },
    model: {
      value: (_vm.checkPersonArr),
      callback: function($$v) {
        _vm.checkPersonArr = $$v
      },
      expression: "checkPersonArr"
    }
  }, _vm._l((_vm.nextFlowStaffArr), function(item) {
    return _c('checker-item', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.checkTreeShow) ? _c('div', [_c('group', {
    attrs: {
      "id": "searchBar"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "搜索",
      "placeholder": "在此输入姓名"
    },
    on: {
      "on-click-clear-icon": _vm.clearSearchResult
    },
    model: {
      value: (_vm.checkTreeSearchVal),
      callback: function($$v) {
        _vm.checkTreeSearchVal = $$v
      },
      expression: "checkTreeSearchVal"
    }
  }, [_c('x-button', {
    attrs: {
      "slot": "right",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.treeSearch($event)
      }
    },
    slot: "right"
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "searchResult"
    }
  }, [_c('ul', _vm._l((_vm.checkTreeSearchResult), function(item) {
    return _c('li', [_c('span', [_c('x-button', {
      nativeOn: {
        "click": function($event) {
          _vm.addToTree(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)])
  }))]), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    attrs: {
      "id": "checkType",
      "data": _vm.treeData,
      "props": _vm.treeProps,
      "node-key": "id",
      "show-checkbox": ""
    },
    on: {
      "check-change": _vm.getCheckedNodes
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "confirmSub"
    }
  }, [_c('x-button', {
    attrs: {
      "disabled": !_vm.confirmBtn,
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirmAudit($event)
      }
    }
  }, [_vm._v("确认提交")])], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('x-input', {
    staticClass: "weui-vcode",
    attrs: {
      "placeholder": "  请签批"
    },
    model: {
      value: (_vm.opinion),
      callback: function($$v) {
        _vm.opinion = $$v
      },
      expression: "opinion"
    }
  }, [_c('x-button', {
    staticClass: "btn-refuse",
    attrs: {
      "slot": "right",
      "mini": "",
      "disabled": _vm.auditDisable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog($event)
      }
    },
    slot: "right"
  }, [_vm._v("同意")]), _vm._v(" "), _c('x-button', {
    staticClass: "btn-submit",
    attrs: {
      "slot": "right",
      "mini": "",
      "disabled": _vm.rejectDisable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.auditReject($event)
      }
    },
    slot: "right"
  }, [_vm._v("驳回")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef3a9b8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Detail.vue
// module id = kLiv
// module chunks = 0